import { render } from "./SOSButton.vue?vue&type=template&id=1330ea17&scoped=true"
import script from "./SOSButton.vue?vue&type=script&lang=js"
export * from "./SOSButton.vue?vue&type=script&lang=js"

import "./SOSButton.vue?vue&type=style&index=0&id=1330ea17&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1330ea17"]])

export default __exports__